import { Injectable } from '@angular/core';
import { IVideoLayerContext } from '../../../../../../models/project/take/layers/video-layer-model';
import { videoLayerUrls } from '../../../../../../constants/private/urls/projects/video-layer/video-layer-urls';
import { HttpClient } from '@angular/common/http';
import {
    IRemoveVideoLayerRequest,
    IUpdateVideoLayerDryDetailsRequestBody,
    IVideoLayerFinishRecordingRequest,
} from '../../../../../http-models/project/video-layer/video-layer-http-request-model';
import { ITakeInDTO } from '../../../../../../models/project/take/take-model';
import { IEditInDTO } from '../../../../../../models/project/edit/edit-model';

@Injectable()
export class VideoLayerDetailsApiService {
    constructor(private http: HttpClient) {}

    public finishRecording$(request: IVideoLayerFinishRecordingRequest) {
        const url = videoLayerUrls.getFinishedRecordingPUTUrl(request.videoLayerContext);

        return this.http.put<{ take: ITakeInDTO }>(url, { endTime: request.endTime, startTime: request.startTime });
    }
    public updateDryDetails$(request: IUpdateVideoLayerDryDetailsRequestBody) {
        const url = videoLayerUrls.getUpdateVideoLayerDetailsFieldsPUTUrl(request.videoLayerContext);
        return this.http.put<{ take: ITakeInDTO }>(url, { fields: request.body });
    }

    public removeVideoLayer$(request: IRemoveVideoLayerRequest) {
        const url = videoLayerUrls.getRemoveVideoLayerDELETEUrl(request.videoLayerContext);
        return this.http.delete<{ take: ITakeInDTO }>(url);
    }
}
